(() => {
  if (window.__shComboNativeFetch) window.fetch = window.__shComboNativeFetch;
  if (window.__shComboOriginalXHROpen) XMLHttpRequest.prototype.open = window.__shComboOriginalXHROpen;
  if (window.__shComboOriginalXHRSend) XMLHttpRequest.prototype.send = window.__shComboOriginalXHRSend;

  const PRODUCT_SELECTOR = '.product--new-standard';
  const BUNDLE_SELECTOR = 'sh-bundle.sh-bundle';
  const LOOP_SELECTOR =
    '.loop-widget-container, .loop-widget-purchase-options-container, [id^="loop-widget-container-id-"]';
  const LOOP_OPTION_SELECTOR =
    '.loop-widget-purchase-option, .loop-w-btn-group-purchase-option, .loop-w-checkbox-purchase-option';
  const ONETIME_OPTION_SELECTOR =
    '.loop-widget-purchase-option-onetime, .loop-w-btn-group-purchase-option-onetime, .loop-w-checkbox-purchase-option-onetime';
  const MAX_BOOT_ATTEMPTS = 40;
  const BOOT_INTERVAL_MS = 250;

  const parseMoneyToCents = (value) => {
    if (value == null || value === '') return null;
    const raw = String(value).trim();
    if (!raw) return null;
    if (/^\d+$/.test(raw)) return parseInt(raw, 10);

    const normalized = raw
      .replace(/[^\d,.-]/g, '')
      .replace(/\.(?=\d{3}(\D|$))/g, '')
      .replace(',', '.');
    const num = Number.parseFloat(normalized);
    if (Number.isNaN(num)) return null;
    return Math.round(num * 100);
  };

  const formatMoneyFromCents = (cents) => {
    const amount = (cents / 100).toFixed(2).replace('.', ',');
    return `${amount} €`;
  };

  const setTextIfChanged = (el, next) => {
    if (!el || el.textContent.trim() === next) return;
    el.textContent = next;
  };

  const getProductRoot = () => document.querySelector(PRODUCT_SELECTOR);

  const getLoopRoot = (product) => {
    if (!product) return null;
    return (
      product.querySelector('.loop-widget-purchase-options-container') ||
      product.querySelector('.loop-w-btn-group-purchase-options-container') ||
      product.querySelector('.loop-w-checkbox-purchase-options-container') ||
      product.querySelector(LOOP_SELECTOR)
    );
  };

  const getSourceBundle = (product) =>
    product?.querySelector(`${BUNDLE_SELECTOR}:not(.sh-combo-bundle-clone)`) || product?.querySelector(BUNDLE_SELECTOR);

  const getOfferTotalCents = (block) => {
    const priceEl = block.querySelector('[data-price]');
    const fromDom = parseMoneyToCents(priceEl?.textContent);
    if (fromDom != null) return fromDom;

    const base = parseMoneyToCents(block.dataset.basePrice);
    const discountType = block.dataset.discountType;
    const discountValue = Number.parseFloat(block.dataset.discountValue || '0') || 0;
    if (base == null) return null;

    if (discountType === 'percentage' && discountValue > 0) {
      return Math.round(base * (1 - discountValue / 100));
    }
    if (discountType === 'fixed' && discountValue > 0) {
      return Math.max(0, base - Math.round(discountValue * 100));
    }
    return base;
  };

  const getSelectedOfferTotalCents = (bundle) => {
    if (!bundle) return null;
    const selected =
      bundle.querySelector('.sh-bundle-block-content.selected, .sh-bundle-block-content[aria-checked="true"]') ||
      bundle.querySelector('input[type="radio"]:checked')?.closest('.sh-bundle-block');
    const block = selected?.closest?.('.sh-bundle-block') || selected || bundle.querySelector('.sh-bundle-block');
    return block ? getOfferTotalCents(block) : null;
  };

  const findOnetimeOption = (loopRoot) =>
    loopRoot.querySelector(ONETIME_OPTION_SELECTOR) ||
    [...loopRoot.querySelectorAll(LOOP_OPTION_SELECTOR)].find((option) => {
      const text = `${option.textContent || ''}`.toLowerCase();
      return text.includes('einmalige') || text.includes('one time') || text.includes('one-time');
    });

  const isOnetimeOption = (option) => {
    if (!option) return false;
    if (option.matches(ONETIME_OPTION_SELECTOR)) return true;
    if (option.hasAttribute('data-loop-widget-onetime-purchase-option')) return true;
    const label = option.querySelector(
      ':scope > .loop-widget-purchase-option-header .loop-widget-purchase-option-label, :scope > .loop-w-btn-group-purchase-option-header .loop-w-btn-group-purchase-option-label, .loop-widget-purchase-option-label, .loop-w-btn-group-purchase-option-label'
    );
    return /einmalige|one time|one-time/.test((label?.textContent || '').toLowerCase());
  };

  const getPurchaseOptions = (loopRoot) =>
    [...loopRoot.querySelectorAll(LOOP_OPTION_SELECTOR)].filter(
      (option) => !option.closest('.sh-combo-nested-bundle')
    );

  let lastPackQty = 1;

  const getProductForm = (product) =>
    product?.querySelector('form.main-product-form') ||
    product?.querySelector('form[data-type="add-to-cart-form"]') ||
    product?.querySelector('form[is="product-form"]');

  const getQuantityInputs = (product) => {
    const inputs = new Set(
      [...(product?.querySelectorAll('input[name="quantity"], input.quantity__input, select[name="quantity"]') || [])]
        .filter((input) => !input.closest(BUNDLE_SELECTOR))
    );
    const form = getProductForm(product);
    if (form) {
      form.querySelectorAll('input[name="quantity"], input.quantity__input, select[name="quantity"]').forEach((input) => {
        if (!input.closest(BUNDLE_SELECTOR)) inputs.add(input);
      });
      if (form.id) {
        document.querySelectorAll(`[form="${form.id}"][name="quantity"]`).forEach((input) => {
          if (!input.closest(BUNDLE_SELECTOR)) inputs.add(input);
        });
      }
    }
    return [...inputs];
  };

  const getBundleQuantity = (bundle) => {
    const selected =
      bundle?.querySelector('.sh-bundle-block-content.selected, .sh-bundle-block-content[aria-checked="true"]')
        ?.closest('.sh-bundle-block') ||
      bundle?.querySelector('input[type="radio"]:checked')?.closest('.sh-bundle-block');
    if (!selected) return null;
    const qty = Number.parseInt(selected.getAttribute('data-quantity') || '', 10);
    return Number.isFinite(qty) && qty > 0 ? qty : null;
  };

  const getOnetimeQuantity = (product, sourceBundle) => {
    const selectedQty = getBundleQuantity(sourceBundle);
    if (selectedQty) {
      if (product) product.dataset.shComboBundleQty = String(selectedQty);
      lastPackQty = selectedQty;
      return selectedQty;
    }
    const savedQty = Number.parseInt(product?.dataset.shComboBundleQty || String(lastPackQty), 10);
    const qty = Number.isFinite(savedQty) && savedQty > 0 ? savedQty : lastPackQty > 0 ? lastPackQty : 1;
    lastPackQty = qty;
    return qty;
  };

  const disarmFormFields = (root) => {
    if (!root) return;
    root.querySelectorAll('input[name], select[name], textarea[name]').forEach((el) => {
      if (!el.dataset.shComboName) el.dataset.shComboName = el.getAttribute('name');
      el.removeAttribute('name');
    });
  };

  const SH_FIELD_NAME = /^(properties\[_sh-|shopify-additional-items\[)/i;

  const stripShSyncedFields = (root) => {
    if (!root) return;
    root.querySelectorAll('[data-sh-bundle-sync]').forEach((el) => el.remove());
    root.querySelectorAll('input[name], select[name], textarea[name]').forEach((el) => {
      const name = el.getAttribute('name') || '';
      if (SH_FIELD_NAME.test(name) || name.includes('_sh-bundle') || name.includes('_sh-upsell')) el.remove();
    });
  };

  const prepareSubscriptionForm = (product) => {
    const sourceBundle = getSourceBundle(product);
    setSourceBundleActive(sourceBundle, false);
    disarmFormFields(sourceBundle);
    stripShSyncedFields(product);
    stripShSyncedFields(getProductForm(product));
    setProductQuantity(product, getOnetimeQuantity(product, sourceBundle), false);
  };

  const setProductQuantity = (product, quantity, emitEvents = true) => {
    const qty = Math.max(1, Number.parseInt(quantity, 10) || 1);
    getQuantityInputs(product).forEach((input) => {
      input.value = String(qty);
      if (!emitEvents) return;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  };

  const setSourceBundleActive = (sourceBundle, active) => {
    if (!sourceBundle) return;
    if (active) sourceBundle.removeAttribute('disabled');
    else sourceBundle.setAttribute('disabled', '');
  };

  const syncPurchaseQuantity = (product, sourceBundle, subscription) => {
    disarmFormFields(sourceBundle);
    if (subscription) {
      prepareSubscriptionForm(product);
      return;
    }
    setSourceBundleActive(sourceBundle, true);
    setProductQuantity(product, 1, false);
  };

  const clearSellingPlanFields = (product) => {
    product.querySelectorAll('input[name="selling_plan"], select[name="selling_plan"]').forEach((el) => {
      el.value = '';
    });
  };

  let lastComboMode = null;
  const setComboMode = (product, subscription) => {
    product.classList.toggle('sh-purchase-combo--subscription', subscription);
    product.classList.toggle('sh-purchase-combo--onetime', !subscription);
    syncPurchaseQuantity(product, getSourceBundle(product), subscription);
    if (!subscription) {
      clearSellingPlanFields(product);
      const sourceBundle = getSourceBundle(product);
      const qty = getOnetimeQuantity(product, sourceBundle);
      if (lastComboMode === 'subscription' && sourceBundle && qty) {
        selectSourceOffer(sourceBundle, String(qty));
      }
    }
    lastComboMode = subscription ? 'subscription' : 'onetime';
  };

  const getMainSubmitButton = (form) =>
    form?.querySelector('.product-form__submit[type="submit"], button[name="add"][type="submit"], [type="submit"][name="add"]');

  const isStickyAtcButton = (control, product) => {
    if (!control?.closest('sticky-atc-bar-minimalist, sticky-atc-bar, .sticky-atc-bar')) return null;
    const form = getProductForm(product);
    if (!form) return null;
    if (control.form === form) return control;
    const formId = control.getAttribute('form');
    if (formId && form.id && formId === form.id) return control;
    if (form.contains(control)) return control;
    return null;
  };

  const isMainProductAtcButton = (target, product) => {
    const form = getProductForm(product);
    if (!form) return null;
    const control = target.closest('button[type="submit"], button[name="add"], .product-form__submit');
    if (!control) return null;
    if (
      control.closest(
        'sh-product-bundles, .sh-product-bundles, .sh-combo-nested-bundle, .sh-combo-source-bundle, .loop-widget-sp-button'
      )
    ) {
      return null;
    }
    if (control.getAttribute('name') === 'plus' || control.getAttribute('name') === 'minus') return null;
    if (isStickyAtcButton(control, product)) return control;
    if (!form.contains(control)) return null;
    return control;
  };

  const isSubscriptionSelected = (product, loopRoot) => {
    const options = getPurchaseOptions(loopRoot);
    const selected =
      options.find(
        (option) =>
          option.classList.contains('loop-widget-purchase-option-selected') ||
          option.classList.contains('loop-w-btn-group-purchase-option-selected')
      ) || options.find((option) => option.getAttribute('aria-checked') === 'true');
    if (selected) return !isOnetimeOption(selected);
    return product.classList.contains('sh-purchase-combo--subscription');
  };

  const isNestedComboControl = (target) =>
    !!target.closest('.sh-combo-nested-bundle') ||
    !!target.closest('.loop-widget-sp-button') ||
    !!target.closest('.loop-widget-sp-selector') ||
    !!target.closest('.sh-combo-freq-dropdown');

  const getSparaboOption = (loopRoot) =>
    getPurchaseOptions(loopRoot).find((option) => !isOnetimeOption(option));

  const getSparaboPriceEl = (sparabo) =>
    sparabo?.querySelector(
      '.loop-widget-purchase-option-price, .loop-w-btn-group-purchase-option-price, .loop-w-checkbox-purchase-option-price'
    ) || null;

  const planPrices = new Map();
  let planPricePromise = null;

  const productJsonUrl = () => {
    const path = window.location.pathname.replace(/\/$/, '');
    if (!/\/products\//.test(path)) return null;
    return `${path}.js`;
  };

  const hydratePlanPrices = () => {
    if (planPricePromise) return planPricePromise;
    const url = productJsonUrl();
    if (!url) {
      planPricePromise = Promise.resolve();
      return planPricePromise;
    }
    planPricePromise = fetch(url)
      .then((res) => res.json())
      .then((json) => {
        (json.variants || []).forEach((variant) => {
          (variant.selling_plan_allocations || []).forEach((alloc) => {
            if (alloc.selling_plan_id == null || alloc.price == null) return;
            planPrices.set(`${variant.id}:${alloc.selling_plan_id}`, alloc.price);
          });
        });
      })
      .catch(() => {
        planPricePromise = null;
      });
    return planPricePromise;
  };

  const getCurrentVariantId = (product) =>
    product.querySelector(
      'form[is="product-form"] [name="id"], form[data-type="add-to-cart-form"] [name="id"], form.main-product-form [name="id"]'
    )?.value || '';

  const getPlanUnitCents = (product, planId) => {
    if (!planId) return null;
    const variantId = getCurrentVariantId(product);
    const exact = planPrices.get(`${variantId}:${planId}`);
    if (exact != null) return exact;
    for (const [key, cents] of planPrices) {
      if (key.endsWith(`:${planId}`)) return cents;
    }
    return null;
  };

  const getFreqPlanId = (btn) => btn?.getAttribute('data-selling-plan-id') || btn?.dataset.sellingPlanId || '';

  const getShPriceBlock = (product) => {
    const info = product?.closest('product-info') || product;
    return info?.querySelector('sh-price-block') || null;
  };

  // Unit reference price for the struck price: compare-at if the variant is on sale,
  // else its regular price. Read only from the variant JSON — never from the
  // rendered compare element, which this script writes itself (qty × compare fed
  // back in on every refresh made the struck price grow exponentially).
  const getVariantCompareCents = (product) => {
    const block = getShPriceBlock(product);
    try {
      const variants = JSON.parse(block?.querySelector('[data-sh-price-variants]')?.textContent || '[]');
      const id = getCurrentVariantId(product);
      const match = variants.find((item) => String(item.id) === String(id)) || variants[0];
      const price = Number.parseInt(match?.price ?? '', 10);
      const compare = Number.parseInt(match?.compare_at ?? match?.compareAt ?? '', 10);
      if (Number.isFinite(compare) && compare > 0 && !(compare <= price)) return compare;
      if (Number.isFinite(price) && price > 0) return price;
    } catch {
      /* ignore */
    }
    return null;
  };

  const getPercentBadgeTemplate = (block) => {
    try {
      const config = JSON.parse(block?.querySelector('[data-sh-price-config]')?.textContent || '{}');
      const def = (config.badges || []).find((item) => item?.type === 'percent');
      if (def?.text) return def;
    } catch {
      /* ignore */
    }
    return { text: 'SPARE {value}%', bg: '#d12b2c', color: '#ffffff', radius: 6, size: 13 };
  };

  const updateShPriceDiscount = (product, priceCents) => {
    const block = getShPriceBlock(product);
    if (!block || priceCents == null) return;

    const sourceBundle = getSourceBundle(product);
    const packQty = sourceBundle ? getOnetimeQuantity(product, sourceBundle) : 1;
    const unitCompare = getVariantCompareCents(product);
    const compareCents = unitCompare != null ? unitCompare * packQty : null;
    const onSale = compareCents != null && compareCents > priceCents;

    const currentEl = block.querySelector('[data-sh-price-current]');
    const compareEl = block.querySelector('[data-sh-price-compare]');
    const badgesEl = block.querySelector('[data-sh-price-badges]');
    if (currentEl) currentEl.classList.toggle('is-on-sale', onSale);

    if (compareEl) {
      if (onSale) {
        setTextIfChanged(compareEl, formatMoneyFromCents(compareCents));
        compareEl.removeAttribute('hidden');
      } else {
        compareEl.setAttribute('hidden', '');
      }
    }

    if (!badgesEl) return;
    if (!onSale) {
      badgesEl.textContent = '';
      return;
    }

    const percent = Math.round(((compareCents - priceCents) / compareCents) * 100);
    if (percent <= 0) {
      badgesEl.textContent = '';
      return;
    }

    const def = getPercentBadgeTemplate(block);
    const text = String(def.text || 'SPARE {value}%').replace(/\{value\}/g, String(percent));
    let badge = badgesEl.querySelector('.sh-price__badge');
    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'sh-price__badge';
      if (def.bg) badge.style.backgroundColor = def.bg;
      if (def.color) badge.style.color = def.color;
      if (def.radius != null) badge.style.borderRadius = `${def.radius}px`;
      if (def.size) badge.style.fontSize = `${def.size}px`;
      badgesEl.appendChild(badge);
    }
    setTextIfChanged(badge, text);
  };

  const getOptionPriceEl = (option) =>
    option?.querySelector(
      '.loop-widget-purchase-option-price, .loop-w-btn-group-purchase-option-price, .loop-w-checkbox-purchase-option-price'
    ) || null;

  const writePriceIntoRoot = (root, formatted) => {
    if (!root) return;
    const sale = root.querySelector('.f-price__sale .f-price-item--sale');
    const regular = root.querySelector('.f-price__regular > .f-price-item--regular');
    if (root.classList.contains('f-price--on-sale') && sale) setTextIfChanged(sale, formatted);
    else if (regular) setTextIfChanged(regular, formatted);
    else if (sale) setTextIfChanged(sale, formatted);
  };

  const setMainProductPrice = (product, formatted, cents) => {
    if (!product || !formatted) return;
    const info = product.closest('product-info');
    const priceRoot =
      info?.querySelector('[id^="price-"] .f-price') ||
      product.querySelector('[id^="price-"] .f-price, .product__block--price .f-price');
    writePriceIntoRoot(priceRoot, formatted);

    const stickyRoot = (info?.parentElement || document).querySelector(
      'sticky-atc-bar-minimalist .f-price, sticky-atc-bar .f-price'
    );
    writePriceIntoRoot(stickyRoot, formatted);

    product.querySelectorAll('[data-sh-price-current], .sh-price__current').forEach((el) => {
      setTextIfChanged(el, formatted);
    });

    const priceCents = cents != null ? cents : parseMoneyToCents(formatted);
    if (priceCents != null) {
      updateShPriceDiscount(product, priceCents);
      window.requestAnimationFrame(() => updateShPriceDiscount(product, priceCents));
      window.setTimeout(() => updateShPriceDiscount(product, priceCents), 120);
    }
  };

  const syncSubscriptionPrices = (product, loopRoot, packQty, updateMain) => {
    const sparabo = getSparaboOption(loopRoot);
    if (!sparabo) return;
    const qty = Math.max(1, Number.parseInt(packQty, 10) || 1);
    const buttons = getLoopFreqButtons(sparabo);
    const selected = getSelectedLoopFreqButton(buttons);
    const unitCents = getPlanUnitCents(product, getFreqPlanId(selected));
    if (unitCents == null) {
      const fallback = getSparaboPriceEl(sparabo)?.textContent?.trim();
      if (updateMain && fallback) setMainProductPrice(product, fallback, parseMoneyToCents(fallback));
      return;
    }
    const formatted = formatMoneyFromCents(unitCents * qty);
    setTextIfChanged(getSparaboPriceEl(sparabo), formatted);
    if (updateMain) setMainProductPrice(product, formatted, unitCents * qty);
  };

  const syncMainFromSelection = (product, loopRoot, sourceBundle) => {
    if (loopRoot) {
      const subscription = isSubscriptionSelected(product, loopRoot);
      const packQty = sourceBundle ? getOnetimeQuantity(product, sourceBundle) : 1;
      if (subscription) {
        syncSubscriptionPrices(product, loopRoot, packQty, true);
        return;
      }
      if (sourceBundle) {
        syncOnetimePrices(product, findOnetimeOption(loopRoot), sourceBundle, true);
        return;
      }
      const formatted = getOptionPriceEl(findOnetimeOption(loopRoot))?.textContent?.trim();
      if (formatted) setMainProductPrice(product, formatted, parseMoneyToCents(formatted));
      return;
    }
    if (!sourceBundle) return;
    const totalCents = getSelectedOfferTotalCents(sourceBundle);
    if (totalCents != null) setMainProductPrice(product, formatMoneyFromCents(totalCents), totalCents);
  };

  const getLoopFreqButtons = (sparabo) =>
    [...(sparabo?.querySelectorAll('.loop-widget-sp-button') || [])].filter(
      (btn) => !btn.closest('.sh-combo-freq-dropdown')
    );

  const getSelectedLoopFreqButton = (buttons) =>
    buttons.find(
      (btn) =>
        btn.classList.contains('loop-widget-sp-button-selected') ||
        btn.getAttribute('aria-checked') === 'true'
    ) || buttons[0];

  const freqButtonLabel = (btn) => (btn?.textContent || '').replace(/\s+/g, ' ').trim();

  const closeFreqDropdown = (dropdown) => {
    if (!dropdown) return;
    dropdown.classList.remove('sh-combo-freq-dropdown--open');
    const trigger = dropdown.querySelector('.sh-combo-freq-trigger');
    const panel = dropdown.querySelector('.sh-combo-freq-panel');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    if (panel) panel.setAttribute('aria-hidden', 'true');
  };

  const closeAllFreqDropdowns = (product) => {
    product.querySelectorAll('.sh-combo-freq-dropdown--open').forEach(closeFreqDropdown);
  };

  const toggleFreqDropdown = (dropdown) => {
    if (!dropdown) return;
    const willOpen = !dropdown.classList.contains('sh-combo-freq-dropdown--open');
    dropdown.closest('.product--new-standard')
      ?.querySelectorAll('.sh-combo-freq-dropdown--open')
      .forEach((open) => {
        if (open !== dropdown) closeFreqDropdown(open);
      });
    dropdown.classList.toggle('sh-combo-freq-dropdown--open', willOpen);
    const trigger = dropdown.querySelector('.sh-combo-freq-trigger');
    const panel = dropdown.querySelector('.sh-combo-freq-panel');
    if (trigger) trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    if (panel) panel.setAttribute('aria-hidden', willOpen ? 'false' : 'true');
  };

  const syncFreqDropdown = (product, loopRoot) => {
    const sparabo = getSparaboOption(loopRoot);
    if (!sparabo) return;

    const buttons = getLoopFreqButtons(sparabo);
    let dropdown = sparabo.querySelector(':scope > .sh-combo-freq-dropdown');

    if (buttons.length < 2) {
      if (dropdown) dropdown.remove();
      return;
    }

    if (!dropdown) {
      dropdown = document.createElement('div');
      dropdown.className = 'sh-combo-freq-dropdown';
      dropdown.innerHTML =
        '<button type="button" class="sh-combo-freq-trigger" aria-haspopup="listbox" aria-expanded="false">' +
        '<span class="sh-combo-freq-trigger-label"></span>' +
        '<span class="sh-combo-freq-badge">Empfehlung</span>' +
        '<span class="sh-combo-freq-chevron" aria-hidden="true"></span>' +
        '</button>' +
        '<div class="sh-combo-freq-panel" role="listbox" aria-hidden="true"></div>';
      const header = sparabo.querySelector('.loop-widget-purchase-option-header');
      if (header) header.insertAdjacentElement('afterend', dropdown);
      else sparabo.appendChild(dropdown);
    }

    const selected = getSelectedLoopFreqButton(buttons);
    const trigger = dropdown.querySelector('.sh-combo-freq-trigger');
    if (trigger && !trigger.querySelector('.sh-combo-freq-badge')) {
      const badge = document.createElement('span');
      badge.className = 'sh-combo-freq-badge';
      badge.textContent = 'Empfehlung';
      const chevron = trigger.querySelector('.sh-combo-freq-chevron');
      if (chevron) trigger.insertBefore(badge, chevron);
      else trigger.appendChild(badge);
    }
    const labelEl = dropdown.querySelector('.sh-combo-freq-trigger-label');
    setTextIfChanged(labelEl, freqButtonLabel(selected));
    const selectedIndex = Math.max(0, buttons.indexOf(selected));
    const triggerBadge = dropdown.querySelector('.sh-combo-freq-trigger .sh-combo-freq-badge');
    if (triggerBadge) triggerBadge.hidden = selectedIndex !== 0;

    const packQty = getOnetimeQuantity(product, getSourceBundle(product));
    const panel = dropdown.querySelector('.sh-combo-freq-panel');
    const options = [...panel.querySelectorAll('.sh-combo-freq-option')];
    const needsRebuild =
      options.length !== buttons.length ||
      options.some((opt, index) => opt.dataset.shComboFreqId !== (buttons[index].id || String(index))) ||
      options.some((opt) => !opt.querySelector('.sh-combo-freq-option-label')) ||
      !options[0]?.querySelector('.sh-combo-freq-badge');

    if (needsRebuild) {
      panel.innerHTML = '';
      buttons.forEach((btn, index) => {
        const opt = document.createElement('button');
        opt.type = 'button';
        opt.className = 'sh-combo-freq-option';
        opt.setAttribute('role', 'option');
        opt.dataset.shComboFreqId = btn.id || String(index);
        opt.innerHTML =
          '<span class="sh-combo-freq-option-label"></span>' +
          (index === 0 ? '<span class="sh-combo-freq-badge">Empfehlung</span>' : '') +
          '<span class="sh-combo-freq-option-price"></span>';
        panel.appendChild(opt);
      });
    }

    [...panel.querySelectorAll('.sh-combo-freq-option')].forEach((opt, index) => {
      const btn = buttons[index];
      const isSelected = btn === selected;
      opt.classList.toggle('is-selected', isSelected);
      opt.setAttribute('aria-selected', isSelected ? 'true' : 'false');
      setTextIfChanged(opt.querySelector('.sh-combo-freq-option-label'), freqButtonLabel(btn));
      const unitCents = getPlanUnitCents(product, getFreqPlanId(btn));
      const priceEl = opt.querySelector('.sh-combo-freq-option-price');
      if (priceEl) {
        setTextIfChanged(priceEl, unitCents == null ? '' : formatMoneyFromCents(unitCents * packQty));
      }
    });

    if (!product.classList.contains('sh-purchase-combo--subscription')) {
      closeFreqDropdown(dropdown);
    }
  };

  const hideOriginalBundleBlock = (bundle) => {
    const block = bundle.closest('.product__block') || bundle.closest('.shopify-app-block')?.parentElement;
    if (block) block.classList.add('sh-combo-source-bundle');
  };

  const unnestBundleClone = (product, sourceBundle) => {
    product.querySelectorAll('.sh-combo-nested-bundle').forEach((nest) => nest.remove());
    const block =
      sourceBundle?.closest('.product__block') || sourceBundle?.closest('.shopify-app-block')?.parentElement;
    if (block) block.classList.remove('sh-combo-source-bundle');
  };

  const syncCloneSelection = (source, clone) => {
    const selectedQty =
      source.querySelector('.sh-bundle-block-content.selected, .sh-bundle-block-content[aria-checked="true"]')
        ?.closest('.sh-bundle-block')
        ?.getAttribute('data-quantity') ||
      source.querySelector('input[type="radio"]:checked')?.closest('.sh-bundle-block')?.getAttribute('data-quantity');

    clone.querySelectorAll('.sh-bundle-block').forEach((block) => {
      const isSelected = selectedQty && block.getAttribute('data-quantity') === selectedQty;
      const content = block.querySelector('.sh-bundle-block-content');
      const radio = block.querySelector('input[type="radio"]');
      content?.classList.toggle('selected', !!isSelected);
      if (content) content.setAttribute('aria-checked', isSelected ? 'true' : 'false');
      if (radio) radio.checked = !!isSelected;
    });
  };

  const nestBundleClone = (onetimeOption, sourceBundle) => {
    if (!onetimeOption || !sourceBundle) return null;

    let nest = onetimeOption.querySelector('.sh-combo-nested-bundle');
    if (!nest) {
      nest = document.createElement('div');
      nest.className = 'sh-combo-nested-bundle';
      onetimeOption.appendChild(nest);
    }

    let clone = nest.querySelector('sh-bundle.sh-combo-bundle-clone');
    if (!clone) {
      clone = sourceBundle.cloneNode(true);
      clone.classList.add('sh-combo-bundle-clone');
      clone.removeAttribute('id');
      clone.querySelectorAll('[id]').forEach((el) => el.removeAttribute('id'));
      clone.setAttribute('disabled', '');
      clone.querySelectorAll('input, select, textarea').forEach((el) => {
        if (el.name) el.dataset.shComboName = el.name;
        el.removeAttribute('name');
        el.disabled = true;
        el.tabIndex = -1;
      });
      nest.innerHTML = '';
      nest.appendChild(clone);
    }

    clone.setAttribute('disabled', '');
    hideOriginalBundleBlock(sourceBundle);
    disarmFormFields(clone);
    syncCloneSelection(sourceBundle, clone);
    return clone;
  };

  const selectSourceOffer = (sourceBundle, quantity) => {
    if (!sourceBundle || !quantity) return;
    const block = sourceBundle.querySelector(`.sh-bundle-block[data-quantity="${quantity}"]`);
    const content = block?.querySelector('.sh-bundle-block-content');
    const radio = block?.querySelector('input[type="radio"]');
    if (radio) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
      radio.dispatchEvent(new Event('input', { bubbles: true }));
    }
    content?.click();
  };

  const syncOnetimePrices = (product, onetimeOption, bundle, updateMain) => {
    const totalCents = getSelectedOfferTotalCents(bundle);
    if (totalCents == null) return;
    const formatted = formatMoneyFromCents(totalCents);

    const optionPrice =
      onetimeOption?.querySelector(
        '.loop-widget-purchase-option-price, .loop-w-btn-group-purchase-option-price, .loop-w-checkbox-purchase-option-price'
      ) || null;
    setTextIfChanged(optionPrice, formatted);

    if (updateMain) setMainProductPrice(product, formatted, totalCents);
  };

  const applyComboState = (product) => {
    const loopRoot = getLoopRoot(product);
    const hasLoop = !!(loopRoot && loopRoot.querySelector(LOOP_OPTION_SELECTOR));
    const sourceBundle = getSourceBundle(product);
    if (!hasLoop && !sourceBundle) return false;

    product.classList.toggle('sh-purchase-combo', hasLoop);
    product.classList.toggle('sh-purchase-combo--with-bundle', !!sourceBundle);
    product.classList.toggle('sh-purchase-combo--bundle-only', !!sourceBundle && !hasLoop);

    if (hasLoop && sourceBundle) unnestBundleClone(product, sourceBundle);

    if (!hasLoop) {
      syncMainFromSelection(product, null, sourceBundle);
      return true;
    }

    const onetimeOption = findOnetimeOption(loopRoot);
    const subscription = isSubscriptionSelected(product, loopRoot);
    setComboMode(product, subscription);

    const packQty = sourceBundle ? getOnetimeQuantity(product, sourceBundle) : 1;
    if (sourceBundle) syncOnetimePrices(product, onetimeOption, sourceBundle, false);
    if (sourceBundle || subscription) syncSubscriptionPrices(product, loopRoot, packQty, false);
    syncMainFromSelection(product, loopRoot, sourceBundle);
    syncFreqDropdown(product, loopRoot);
    hydratePlanPrices().then(() => {
      if (!planPrices.size) return;
      const live = getProductRoot() || product;
      const liveLoop = getLoopRoot(live);
      const liveBundle = getSourceBundle(live);
      const liveQty = liveBundle ? getOnetimeQuantity(live, liveBundle) : 1;
      if (liveBundle || (liveLoop && isSubscriptionSelected(live, liveLoop))) {
        syncSubscriptionPrices(live, liveLoop, liveQty, false);
      }
      if (liveLoop) {
        syncMainFromSelection(live, liveLoop, liveBundle);
        syncFreqDropdown(live, liveLoop);
      }
    });
    return true;
  };

  let bound = false;
  const bindInteractions = (product) => {
    if (bound) return;
    bound = true;

    const currentProduct = () => getProductRoot() || product;
    const refresh = () =>
      window.requestAnimationFrame(() => {
        const live = currentProduct();
        if (live) applyComboState(live);
      });

    const prepareComboSubmit = (live) => {
      if (!live?.classList.contains('sh-purchase-combo--with-bundle')) return;
      if (live.classList.contains('sh-purchase-combo--subscription')) {
        prepareSubscriptionForm(live);
        return;
      }
      setProductQuantity(live, 1, false);
      clearSellingPlanFields(live);
    };

    const submitProductForm = (live, addControl) => {
      const form = getProductForm(live);
      if (!form) return;
      const mainSubmit = getMainSubmitButton(form);
      mainSubmit?.removeAttribute('aria-disabled');
      addControl?.removeAttribute('aria-disabled');
      form.requestSubmit(mainSubmit || addControl || undefined);
    };

    document.addEventListener(
      'change',
      (event) => {
        const live = currentProduct();
        const target = event.target;
        if (!live || !(target instanceof Element) || !live.contains(target)) return;
        if (target.closest('.sh-combo-bundle-clone')) return;
        if (
          live.classList.contains('sh-purchase-combo--subscription') &&
          target.matches('input[name="quantity"], input.quantity__input')
        ) {
          setProductQuantity(live, getOnetimeQuantity(live, getSourceBundle(live)), false);
          return;
        }
        if (target.closest(LOOP_SELECTOR) || target.closest(BUNDLE_SELECTOR) || target.closest(LOOP_OPTION_SELECTOR)) {
          refresh();
        }
      },
      true
    );

    document.addEventListener(
      'submit',
      (event) => {
        const live = currentProduct();
        const form = event.target;
        if (!live || !(form instanceof HTMLFormElement)) return;
        if (form !== getProductForm(live) && !live.contains(form)) return;
        if (!live.classList.contains('sh-purchase-combo--with-bundle')) return;
        const submitter = event.submitter;
        if (submitter && !isMainProductAtcButton(submitter, live)) return;
        prepareComboSubmit(live);
      },
      true
    );

    document.addEventListener('product-ajax:added', () => {
      window.requestAnimationFrame(() => {
        const live = currentProduct();
        if (!live?.classList.contains('sh-purchase-combo--with-bundle')) return;
        prepareComboSubmit(live);
      });
    });

    if (window.FoxTheme?.pubsub?.subscribe && FoxTheme.pubsub.PUB_SUB_EVENTS?.variantChange) {
      FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, () => {
        window.setTimeout(refresh, 50);
        window.setTimeout(refresh, 220);
      });
    }

    document.addEventListener(
      'click',
      (event) => {
        const live = currentProduct();
        const target = event.target;
        if (!live || !(target instanceof Element)) return;
        const addControlEarly = isMainProductAtcButton(target, live);
        if (!live.contains(target) && !addControlEarly) return;

        const freqDropdown = target.closest('.sh-combo-freq-dropdown');
        if (freqDropdown) {
          event.preventDefault();
          event.stopPropagation();
          const optionBtn = target.closest('.sh-combo-freq-option');
          if (optionBtn) {
            const sparabo = freqDropdown.closest(LOOP_OPTION_SELECTOR);
            const buttons = getLoopFreqButtons(sparabo);
            const index = [...freqDropdown.querySelectorAll('.sh-combo-freq-option')].indexOf(optionBtn);
            const loopBtn = buttons[index];
            closeFreqDropdown(freqDropdown);
            if (loopBtn) loopBtn.click();
            window.setTimeout(refresh, 60);
            return;
          }
          if (target.closest('.sh-combo-freq-trigger')) {
            toggleFreqDropdown(freqDropdown);
          }
          return;
        }

        const cloneCard = target.closest('.sh-combo-bundle-clone .sh-bundle-block-content');
        if (cloneCard) {
          event.preventDefault();
          event.stopPropagation();
          const qty = cloneCard.closest('.sh-bundle-block')?.getAttribute('data-quantity');
          selectSourceOffer(getSourceBundle(live), qty);
          if (qty) {
            live.dataset.shComboBundleQty = String(qty);
            lastPackQty = Number.parseInt(qty, 10) || lastPackQty;
            setProductQuantity(live, 1, false);
          }
          refresh();
          window.setTimeout(refresh, 80);
          return;
        }

        const sourceCard = target.closest('sh-bundle.sh-bundle:not(.sh-combo-bundle-clone) .sh-bundle-block-content');
        if (sourceCard && live.contains(sourceCard)) {
          const qty = sourceCard.closest('.sh-bundle-block')?.getAttribute('data-quantity');
          if (qty) {
            live.dataset.shComboBundleQty = String(qty);
            lastPackQty = Number.parseInt(qty, 10) || lastPackQty;
          }
        }

        const addControl = isMainProductAtcButton(target, live);
        if (addControl && live.classList.contains('sh-purchase-combo--with-bundle')) {
          const sticky = !!isStickyAtcButton(addControl, live);
          if (live.classList.contains('sh-purchase-combo--subscription') || sticky) {
            event.preventDefault();
            event.stopImmediatePropagation();
            prepareComboSubmit(live);
            submitProductForm(live, addControl);
            return;
          }
          setProductQuantity(live, 1, false);
          clearSellingPlanFields(live);
        }

        const option = target.closest(LOOP_OPTION_SELECTOR);
        if (option && live.contains(option) && !isNestedComboControl(target)) {
          setComboMode(live, !isOnetimeOption(option));
          window.setTimeout(refresh, 60);
          window.setTimeout(refresh, 160);
          return;
        }

        if (option || target.closest('.sh-bundle-block-content')) {
          window.setTimeout(refresh, 60);
          window.setTimeout(refresh, 160);
        }
      },
      true
    );

    document.addEventListener('click', (event) => {
      const live = currentProduct();
      const target = event.target;
      if (!live || !(target instanceof Element) || target.closest('.sh-combo-freq-dropdown')) return;
      closeAllFreqDropdowns(live);
    });
  };

  const boot = () => {
    const product = getProductRoot();
    if (!product) return;

    bindInteractions(product);

    let attempts = 0;
    const timer = window.setInterval(() => {
      attempts += 1;
      const live = getProductRoot() || product;
      const ready = applyComboState(live);
      const hasLoop = !!getLoopRoot(live)?.querySelector(LOOP_OPTION_SELECTOR);
      if ((ready && hasLoop) || attempts >= MAX_BOOT_ATTEMPTS) window.clearInterval(timer);
    }, BOOT_INTERVAL_MS);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
